import { Injectable } from '@angular/core'
import { HttpService, IExportFileResponse } from '@lla-platform/core/core-data-access'
import { DateService } from '@lla-platform/core/core-util'
import { Observable } from 'rxjs'
import { SALARIES_SUMMARY_API_URL } from './admin-api-routes'
import {
  ISalariesSummaryRequest,
  ISalariesSummaryResponse
} from '../interfaces/salaries-summary.interface'

@Injectable({
  providedIn: 'root'
})
export class SalariesSummaryService {
  constructor(
    private http: HttpService,
    private dateService: DateService
  ) {}

  getSalariesSummary(payload: ISalariesSummaryRequest): Observable<ISalariesSummaryResponse> {
    const { from, to } = payload
    return this.http.post(SALARIES_SUMMARY_API_URL.summary, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }

  exportSalariesSummary(payload: ISalariesSummaryRequest): Observable<IExportFileResponse> {
    const { from, to } = payload
    return this.http.post(SALARIES_SUMMARY_API_URL.export, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }
}
